import React, { useState, useContext } from "react";
import styles from "./ContactPage.module.scss"; // Assurez-vous d'avoir un fichier SCSS correspondant

import { LanguageContext } from '../../context/LanguageContext';

import Footer from '../../components/Footer/Footer';

// Import des traductions 
import translations from '../../utils/translations/ContactTranslations';

const ContactPage = () => {

    // Utilisation du contexte de langue global
    const { language, changeLanguage } = useContext(LanguageContext);

    // Accès simplifié aux traductions
    const t = translations[language] || translations.fr;

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        issueType: "",
        message: ""
    });
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
        const response = await fetch("/api/sendMail", {// A modifier
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            to: "contact@hatanna-edition.fr",
            cc: "dev@scriptales.fr",
            subject: `Problème rencontré - ${formData.issueType}`,
            text: `Nom: ${formData.lastName}\nPrénom: ${formData.firstName}\nEmail: ${formData.email}\n\nProblème rencontré: ${formData.issueType}\n\nMessage:\n${formData.message}`
            })
        });

        if (response.ok) {
            setSuccess("Votre message a bien été envoyé.");
            setFormData({ firstName: "", lastName: "", email: "", issueType: "", message: "" });
        } else {
            throw new Error("Échec de l'envoi du message.");
        }
        } catch (err) {
        setError("Une erreur est survenue. Veuillez réessayer plus tard.");
        }
    };

    return (
        <>
            <div className={styles.container}>
                <div className={styles.content}>
                    <h1 className={styles.title}>{t.contactUsTitle}</h1>
                    <p className={styles.text}>{t.contactUsText} <a className={styles.link} href="mailto:contact@hatanna-editions.fr">{t.contactUsLink}</a>.</p>
                    <p className={styles.text}>{t.helpText}</p>

                    {/* <form onSubmit={handleSubmit} className={styles.contactForm}>
                        <div className={styles.formGroup}>
                        <label>Nom :</label>
                        <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required />
                        </div>
                        <div className={styles.formGroup}>
                        <label>Prénom :</label>
                        <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required />
                        </div>
                        <div className={styles.formGroup}>
                        <label>Email :</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required />
                        </div>
                        <div className={styles.formGroup}>
                        <label>Nature du problème :</label>
                        <select name="issueType" value={formData.issueType} onChange={handleChange} required>
                            <option value="">Sélectionner...</option>
                            <option value="Problème technique">Problème technique</option>
                            <option value="Question sur l'utilisation">Question sur l'utilisation</option>
                            <option value="Autre">Autre</option>
                        </select>
                        </div>
                        <div className={styles.formGroup}>
                        <label>Message :</label>
                        <textarea name="message" value={formData.message} onChange={handleChange} required />
                        </div>
                        <button type="submit">Envoyer</button>
                    </form>
                    {success && <p className={styles.success}>{success}</p>}
                    {error && <p className={styles.error}>{error}</p>} */}
                </div>
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default ContactPage;
